export default __webpack_public_path__ + "static/media/05_o_4.6e13989f.jpg";